<template>
    <section class="game">
        <ModalIframe
            v-if="dataGame && dataGame.url"
            :url="`${dataGame.url}&showclose=1&showdownload=1`"
        ></ModalIframe>  

        <ModalTimeLimit 
            v-if="isModalTimeLimit && activeSubProfile && activeSubProfile._id" 
            :isTimeIsUp="isTimeIsUp"
            :isOutOfHours="isOutOfHours"
            :isTimeIsUpRemind="isTimeIsUpRemind"
            :activeSubProfile="activeSubProfile"
            @closeModalHandle="closeModalHandle"
            @stopRecordTime="stopRecordTime">
        </ModalTimeLimit>

        <transition name="fade" appear>
            <PinLock v-if="isPinLock && isPinLock.isOpen"></PinLock>
        </transition>

        <transition name="fade" appear>
            <ModalLogin v-if="isModalLogin"></ModalLogin>
        </transition>
    </section>
</template>

<script>
import axios from "axios";
import ModalIframe from "../modals/ModalIframe.vue";
import ModalTimeLimit from "../modals/ModalTimeLimit.vue";
import PinLock from "../modals/PinLock.vue";
import ModalLogin from "../modals/ModalLogin.vue";
import { recordTime } from '../../mixins/recordTime';
import { registerVisit } from '../../mixins/registerVisit';
import { checkIsOutOfHours } from '../../mixins/checkIsOutOfHours';

export default {
    name: "Game",
    data() {
        return {
            GAME: '/api/krainaabc/news?device=www',
            dataGame: null,
            recordTimeIntervalId: null,
            checkHoursIntervalId: null,
            isModalTimeLimit: false
        };
    },    
    components: {
        ModalIframe,
        ModalTimeLimit,
        PinLock,
        ModalLogin
    },
    watch: {
        isModalTimeLimit(value) {
            if(value) {
                this.$store.dispatch("changeModalBackdrop", true);
                this.$store.dispatch("changeModalTimeLimitState", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
                this.$store.dispatch("changeModalTimeLimitState", false);
            }
        },
        categoryId(value) {
            if(this.activeSubProfile && this.activeSubProfile._id && this.activeSubProfile.game_restriction !==0 && value) {
                if(this.isTimeIsUp || (this.activeSubProfile.remaining_time === 0 && !this.activeSubProfile.play_from)) {
                    if(!this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                        this.isModalTimeLimit = true;  
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null;    
                    }
                } else if(this.isOutOfHours) {
                    this.isModalTimeLimit = true;  
                    clearInterval(this.recordTimeIntervalId);
                    clearInterval(this.checkHoursIntervalId);
                    this.recordTimeIntervalId = null;
                    this.checkHoursIntervalId = null; 
                } else {
                    checkIsOutOfHours();
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                    this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                }

                setTimeout(() => {
                    registerVisit(this.pageId, this.activeSubProfile._id)
                }, 15000);  
            } else {
                 if(this.recordTimeIntervalId) {
                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null;
                }
                if(this.checkHoursIntervalId) {
                    clearInterval(this.checkHoursIntervalId)
                    this.checkHoursIntervalId = null;  
                }                
            }
        },
        isTimeIsUp(value) {
            if(this.activeSubProfile && this.activeSubProfile._id) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 
                } else {
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        },
        isTimeIsUpRemind(value) {
            if(this.activeSubProfile && this.activeSubProfile._id) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  
                }
            }
        },         
        isOutOfHours(value) {
            if(this.activeSubProfile && this.activeSubProfile._id) {
                if(value) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 
                } else {
                    this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        },
        activeSubProfile(value) {
            if(value && value.remaining_time === 0 && !value.play_from) {
                this.$store.dispatch("setIsTimeIsUp", true);
            }  
        }                 
    },
    computed: {
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        pageId() {
            if(this.$route.params.id) {
                return parseInt(this.$route.params.id);
            } else {
                return window.__pageSettings.id;
            }
        },
        categoryId() {
            if (this.dataGame && this.dataGame.breadcrumbs && this.dataGame.breadcrumbs[0] && this.dataGame.breadcrumbs[0]._id) {
                return this.dataGame.breadcrumbs[0]._id
            } else {
                return null;
            }
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        isTimeIsUp() {
            return this.$store.getters.isTimeIsUp;
        },
        isTimeIsUpRemind() {
            return this.$store.getters.isTimeIsUpRemind;
        },
        isOutOfHours() {
            return this.$store.getters.isOutOfHours;
        },
        isPinLock() {
            return this.$store.getters.getPinLock;
        },
        isModalLogin() {
            return this.$store.getters.getModalLogin;
        }
    },
    methods: {
        getData() {
            axios.get(`${this.GAME}&id=${this.pageId}`).then((response) => {
                if (response.status === 200) {
                    if(response.data.data) {
                        this.dataGame = response.data.data;
                    } else {
                        this.$router.push(
                            {
                                name: '404'
                            }
                        );
                    }
                } else {
                    this.$router.push(
                        {
                            name: '404'
                        }
                    );
                }
            })
            .catch(() => {
                this.$router.push(
                    {
                        name: '404'
                    }
                );
            });
        },
        closeModalHandle() {
            this.isModalTimeLimit = false;
        },
        stopRecordTime() {
            clearInterval(this.recordTimeIntervalId);
            this.recordTimeIntervalId = null; 
        },
        receiveMessage(e) {
            if(e.origin === 'http://s.v3.tvp.pl' || e.origin === 'https://s.v3.tvp.pl' || e.origin === 'http://s.tvp.pl' || e.origin === 'https://s.tvp.pl') {
                if(e.data && e.data.close) {
                    this.$router.push(
                        {
                            name: "Gry",
                            params: { id: this.categoryId }
                        }
                    );
                }
            }
        },
    },
    mounted() {
        this.getData();

        window.addEventListener('message', this.receiveMessage);

        if(this.activeSubProfile && this.activeSubProfile._id) {
            checkIsOutOfHours();
        }

        if(this.activeSubProfile && this.activeSubProfile.remaining_time === 0 && !this.activeSubProfile.play_from) {
            this.$store.dispatch("setIsTimeIsUp", true);
        }   

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );
    },
    unmounted() {
        this.$store.dispatch("setIsOutOfHours", false);  
        this.$store.dispatch("setIsTimeIsUp", false);
        this.$store.dispatch("changeModalBackdrop", false);
        this.$store.dispatch("changeModalTimeLimitState", false);
        clearInterval(this.recordTimeIntervalId);
        clearInterval(this.checkHoursIntervalId);
        this.recordTimeIntervalId = null;
        this.checkHoursIntervalId = null;          
    }
};
</script>